module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#photostory",
      toString: function () {
        return this.url;
      }
    }